export function jrSharePanel(shareInfo) {
  let {
    link,
    imgUrl,
    title,
    desc,
  } = shareInfo

  let GlobalShare = window.GlobalShare
  let shareMain = { img: imgUrl, title, desc }

  let shareUrl = [
    { channels: '0', url: link },
    { channels: '1', url: link },
  ]
  GlobalShare.share(shareMain, shareUrl)
}



// WEBPACK FOOTER //
// ./src/public/shareJdjr.js